module.exports = __webpack_public_path__ + "img/perah_yes.e38f092d.png";